"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* global nookInfoExchange */
class PortalBanner extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "checkIfPortalIsPrepared", () => {
      const portalRoot = document.getElementById('portalBanner');
      if (portalRoot) {
        this.setState({
          portalRoot
        });
        const {
          portalInterval
        } = this.state;
        clearInterval(portalInterval);
      }
      return false;
    });
    _defineProperty(this, "componentDidMount", () => {
      const portalInterval = setInterval(() => {
        this.checkIfPortalIsPrepared();
      }, 50);
      this.setState({
        portalInterval
      });
      if (nookInfoExchange && nookInfoExchange.registerAsObserver) {
        nookInfoExchange.registerAsObserver('BannerWhiteBox', 'PortalBanner', msg => {
          const {
            taggingInfo,
            components
          } = msg;
          this.setState({
            taggingInfo,
            components
          });
        });
      }
    });
    this.state = {
      portalRoot: null,
      portalInterval: null,
      taggingInfo: null,
      components: null
    };
  }
  render() {
    const {
      portalRoot,
      taggingInfo,
      components
    } = this.state;
    const {
      children
    } = this.props;
    if (!portalRoot || !taggingInfo) {
      return false;
    }

    // Pass taggingInfo to children
    const childrenWithProps = _react.default.Children.map(children, child => {
      // checking isValidElement is the safe way and avoids a typescript error too
      const objToSend = {
        taggingInfo,
        components
      };
      if ( /*#__PURE__*/_react.default.isValidElement(child)) {
        return /*#__PURE__*/_react.default.cloneElement(child, objToSend);
      }
      return child;
    });
    return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "portalComponent",
      children: childrenWithProps
    }), portalRoot);
  }
}
var _default = PortalBanner;
exports.default = _default;

//# sourceMappingURL=index.js.map